// extracted by mini-css-extract-plugin
module.exports = {"header":"ManualTimeModal_header__22ShG","content":"ManualTimeModal_content__3eHe4"};